<script lang="ts">
	//Services
	import { format } from 'svelte-i18n';

	//Stores
	import { selected_for_car_play } from 'src/stores/features/car-play';
	import { readDeviceStatus } from 'src/stores/device-runtime/status-selectors';
import { devices } from 'src/stores/lists/devices';
	//Helpers
	import { capFirstChar } from 'src/helpers/utilities';
	import { supportedCarPlayDevices } from '../../CarPlayHelpers';

	import { deriveRoomName } from 'src/helpers/service_rooms_helpers';
	//Types
	import type { Device } from 'src/types/Device';
	//Components
	import SelectList from 'src/components/SelectList/SelectList.svelte';

	let selectedDevices = $selected_for_car_play;

	let allItemsRefs: { [key: string | number]: HTMLElement } = {};
	let initial_car_play_list = [...$selected_for_car_play];

	const handleSelection = (item) => {
		const _selectedDevices = [...selectedDevices];
		if (_selectedDevices.includes(item.id)) {
			_selectedDevices.splice(_selectedDevices.indexOf(item.id), 1);
			// item.selected = false;
		} else {
			_selectedDevices.push(item.id);
			// item.selected = true;
		}

		selectedDevices = _selectedDevices;

		selected_for_car_play.set(selectedDevices);
		roomsFiltered = filterDevices(Object.values($devices));
	};

	const filterDevices: any = (array: Device[]) => {
		let filteredDevicesByRoom = {};

		const deletedDevices = initial_car_play_list.filter(
			(dId) => typeof $devices[dId] === 'undefined',
		);

		const filteredArray = supportedCarPlayDevices(array);

		filteredArray.forEach((device: Device, i) => {
			const roomID = device.room_id;

			const deviceData = {
				name: `${device.name}${
					typeof readDeviceStatus(device.id) === 'undefined'
						? `- ${capFirstChar($format('label_offline'))}`
						: ''
				}`,
				id: device.id,
				selected: $selected_for_car_play.findIndex((el) => el === device.id) !== -1,
				roomName: deriveRoomName(roomID),
				roomID: roomID,
				image: device.image ? device.image : undefined,
				backgroundColor: device.backgroundColor ? device.backgroundColor : undefined,
				icon: device.icon ? device.icon : undefined,
				disabled:
					$selected_for_car_play.findIndex((el) => el === device.id) == -1 &&
					$selected_for_car_play.length >= 10,
			};

			if (filteredDevicesByRoom[roomID]) {
				filteredDevicesByRoom[roomID].cards = [
					...filteredDevicesByRoom[roomID].cards,
					deviceData,
				];
			} else {
				filteredDevicesByRoom[roomID] = {
					cards: [deviceData],
					roomName: deriveRoomName(roomID),
					roomID: roomID,
				};
			}
		});

		if (deletedDevices.length) {
			deletedDevices.forEach((id) => {
				const deviceData = {
					name: $format('device_status_deleted', { default: `deleted` }) + `: ${id}`,
					id,
					selected: $selected_for_car_play.findIndex((el) => el === id) !== -1,
					roomName: capFirstChar($format('deleted_devices', { default: 'deleted devices' })),
					roomID: -99,
					icon: 'fas fa-trash',
				};

				if (filteredDevicesByRoom[-99]) {
					filteredDevicesByRoom[-99].cards = [...filteredDevicesByRoom[-99].cards, deviceData];
				} else {
					filteredDevicesByRoom[-99] = {
						cards: [deviceData],
						roomName: capFirstChar(
							$format('deleted_devices', {
								default: 'deleted devices',
							}),
						),
						roomID: -99,
					};
				}
			});
		}

		return Object.values(filteredDevicesByRoom);
	};

	$: roomsFiltered = filterDevices(Object.values($devices));
</script>

<SelectList
	title={$format('label_selected', {
		default: 'Selected:',
	})}
	titleHighlight={$selected_for_car_play.length}
	list={roomsFiltered}
	bind:allCardsRefs={allItemsRefs}
	on:click={(e) => handleSelection(e.detail)}
/>
